<template>
  <header class="article-hero">
    <section
        ref="heroRef"
        class="article-hero__hero-ref"
    >
      <div
          class="article-hero__inner">
        <AppImageFocal v-if="props.image" :data="props.image" :eager="true" :renditions="renditions"/>
      </div>
      <div v-if="props.primaryTag" class="article-hero__content">
        <AppScrollMarquee>
          <span class="article-hero__label">
            {{ sanitizedTitle }}
          </span>
        </AppScrollMarquee>
        <AppScrollMarquee :reverse="true">
          <span class="article-hero__label">
            {{ sanitizedTitle }}
          </span>
        </AppScrollMarquee>
      </div>
    </section>
  </header>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import {sanitizeMarkedHeading} from "~/utils/data-transformers";

const heroRef = ref<HTMLElement>()

const props = defineProps<{
  image: unknown,
  primaryTag: String
}>()

const sanitizedTitle = computed(() => {
  return sanitizeMarkedHeading(props.primaryTag)
})

const renditions = [
  {width: 575, height: 575, breakpoint: 'xs'},
  {width: 767, height: 512, breakpoint: 'sm'},
  {width: 991, height: 662, breakpoint: 'md'},
  {width: 1088, height: 559, breakpoint: 'lg'}
]

</script>

<style scoped lang="postcss">
.article-hero {
  position: sticky;
  top: 0px;
  z-index: 0;
  background-color: var(--color-blue-aqua);

  &__hero-ref {
    @mixin container-lg;
    @mixin app-container-padding-lg;
    @mixin app-grid;
  }

  &__inner {
    grid-column: 1 / -1;
    aspect-ratio: 1 / 1;
    overflow: clip;

    @media (--sm) {
      aspect-ratio: 767/511;
    }

    @media (--lg) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
      aspect-ratio: 756/388;
    }

    @media (--xl) {
      grid-column: span 10 / span 10;
      grid-column-start: 2;
    }
  }

  &__content {
    position: absolute;
    left: 0px;
    top: 50%;
    z-index: -1;
    width: 100%;
    transform: translateY(-50%);
  }

  &__label {
    padding-right: 3rem;
    font-family: Midnight, sans-serif;
    font-size: 100px;
    text-transform: uppercase;
    line-height: 0.8;
    color: var(--color-blue-prussian);

    @media (--lg) {
      font-size: 180px;
    }
  }

  [data-domain="violet"] & {
    background-color: var(--color-violet);
  }

  [data-domain="yellow"] & {
    background-color: var(--color-yellow);
  }

  [data-domain="red"] & {
    background-color: var(--color-red);
  }
}
</style>
